import { render } from "./ProjectPreviewTrial.vue?vue&type=template&id=65e60258"
import script from "./ProjectPreviewTrial.vue?vue&type=script&lang=js"
export * from "./ProjectPreviewTrial.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__